import Results from './prematch/results/Results';
import LiveCategory from './live/category/Category';
import LiveEvent from './live/event/Event';
import LiveFavorites from './live/favorites/Favorites';
import LiveHome from './live/home/Home';
import Live from './live/Live';
import LiveWrapper from './live/LiveWrapper';
import LiveTournament from './live/tournament/TournamentsList';
import MultiliveFetcher from './live/multilive/MultiliveFetcher';
import LiveSport from './live/sport/Sport';
import SportDataProvider from './live/sport/SportDataProvider';
import PrematchCategory from './prematch/Category';
import PrematchFavorites from './prematch/Favorites';
import PrematchHome from './prematch/Home';
import Prematch from './prematch/Prematch';
import PrematchWrapper from './prematch/PrematchWrapper';
import PrematchSport from './prematch/Sport';
import TournamentRoute from './prematch/TournamentRoute';
import TournamentsList from './prematch/TournamentsList';
import TournamentsByDate from './prematch/by-date/TournamentsByDate';
import Statistics from './prematch/statistics/Statistics';
import Redirect from './router/Redirect';
import { livePrefix, prematchPrefix } from './Container';
import DailyFlashOdds from './prematch/daily-flash-odds/DailyFlashOdds';
import AllSports from './prematch/by-date/AllSports';
import Sport from './prematch/by-date/Sport';
import NotFound from './common/NotFound';
import Category from './prematch/by-date/Category';
import Tournament from './prematch/by-date/Tournament';
import Event from './prematch/by-date/Event';
import { showLiveSectionOnly } from './showLiveSectionOnly';

const SPORT_PARAMS = '_:d_sportId';
const CATEGORY_PARAMS = `${SPORT_PARAMS}_:d_categoryId`;
const TOURNAMENT_PARAMS = `${CATEGORY_PARAMS}_:d_tournamentId`;
const EVENT_PARAMS = `${TOURNAMENT_PARAMS}_:d_pal_:d_avv`;

export function getRoutes() {
    const routes = [
        {
            path: '/sport',
            component: <Prematch />,
            nested: [
                {
                    path: '/h-:d_hour',
                    component: <TournamentsByDate />,
                    nested: [
                        {
                            path: `*${EVENT_PARAMS}`,
                            component: <Event />,
                        },
                        {
                            path: `*${TOURNAMENT_PARAMS}`,
                            component: <Tournament />,
                        },
                        {
                            path: `*${CATEGORY_PARAMS}`,
                            component: <Category />,
                        },
                        {
                            path: `*${SPORT_PARAMS}`,
                            component: <Sport />,
                        },
                        {
                            path: '',
                            component: <AllSports />
                        }
                    ]
                },
                {
                    path: '/d-:d_day',
                    component: <TournamentsByDate />,
                    nested: [
                        {
                            path: `*${EVENT_PARAMS}`,
                            component: <Event />,
                        },
                        {
                            path: `*${TOURNAMENT_PARAMS}`,
                            component: <Tournament />,
                        },
                        {
                            path: `*${CATEGORY_PARAMS}`,
                            component: <Category />,
                        },
                        {
                            path: `*${SPORT_PARAMS}`,
                            component: <Sport />,
                        },
                        {
                            path: '',
                            component: <AllSports />
                        }
                    ]
                },
                {
                    path: '',
                    component: <PrematchWrapper />,
                    nested: [
                        {
                            path: `*${EVENT_PARAMS}`,
                            component: <TournamentsList />,
                        },
                        {
                            path: `*${TOURNAMENT_PARAMS}`,
                            component: <TournamentRoute />,
                        },
                        {
                            path: `*${CATEGORY_PARAMS}`,
                            component: <PrematchCategory />,
                        },
                        {
                            path: `*${SPORT_PARAMS}`,
                            component: <PrematchSport />,
                        },
                        {
                            path: '/daily-flash-odds',
                            component: <DailyFlashOdds />,
                        },
                        {
                            path: '/favorites',
                            component: <PrematchFavorites />,
                        },
                        {
                            path: '/results',
                            component: <Results />,
                        },
                        {
                            path: '/statistics',
                            component: <Statistics />,
                        },
                        {
                            path: '',
                            component: <PrematchHome />,
                        },
                    ]
                },
            ]
        },
        {
            path: '',
            component: <Live />,
            nested: [
                {
                    path: '/multilive',
                    component: <MultiliveFetcher />,
                },
                {
                    path: '/live',
                    component: <LiveWrapper />,
                    nested: [
                        {
                            path: '',
                            component: <SportDataProvider />,
                            nested: [
                                {
                                    path: `*${EVENT_PARAMS}`,
                                    component: <LiveEvent />,
                                },
                                {
                                    path: `*${TOURNAMENT_PARAMS}`,
                                    component: <LiveTournament />,
                                },
                                {
                                    path: `*${CATEGORY_PARAMS}`,
                                    component: <LiveCategory />,
                                },
                                {
                                    path: `*${SPORT_PARAMS}`,
                                    component: <LiveSport />,
                                },
                            ]
                        },
                        {
                            path: '/favorites',
                            component: <LiveFavorites />,
                        },
                        {
                            path: '',
                            component: <LiveHome />,
                        },
                    ]
                },
            ]
        },
        {
            path: '404',
            component: <NotFound />
        },
        {
            path: '',
            component: <Redirect path={prematchPrefix} />
        }
    ];

    if (showLiveSectionOnly()) {
        return [
            routes[1],
            routes[2],{
                path: '',
                component: <Redirect path={livePrefix} />
            }
        ];
    }

    return routes;
}
